function addTotal(cartTotal) {
  let newCartTotal = cartTotal.replace(/\$/g, "");
  newCartTotal = parseFloat(newCartTotal);
  if (localStorage.getItem("realift:realsize:session")) {
    if (typeof window.gtag === "function") {
      gtag("event", "realsize_add_total", {
        event_category: "RealSize",
        event_label: "RealSize Add Total",
        value: newCartTotal,
        send_to: "G-4J5PWC1TMH",
      });
      gtag("event", "realsize_add_transaction", {
        event_category: "RealSize",
        event_label: "RealSize Add Transaction",
        value: 1,
        send_to: "G-4J5PWC1TMH",
      });
    }
  }
}

window.onload = function () {
  setTimeout(function () {
    $(document).on("click", '[name="checkout"],[data-testid="ShopifyPay-button"],[data-testid="GooglePay-button"],[data-testid="FacebookPay-button"],[action="https://payments.amazon.com/checkout/signin"]', function () {
      jQuery.getJSON("/cart.js", function (cart) {
        console.log("Clicked");
        addTotal("$" + cart.total_price / 100);
      });
    });
    
    // // Google

    // const googlePay = document.querySelector('[data-testid="GooglePay-button"]');
    // googlePay.addEventListener("click", function () {
    //   jQuery.getJSON("/cart.js", function (cart) {
    //     addTotal("$" + cart.total_price / 100);
    //   });
    // });

    // // Facebook/Meta

    // const facebookPay = document.querySelector('[data-testid="FacebookPay-button"]');
    // facebookPay.addEventListener("click", function () {
    //   jQuery.getJSON("/cart.js", function (cart) {
    //     addTotal("$" + cart.total_price / 100);
    //   });
    // });

    // Sezzle

    //   const sezzlePay = document.querySelector(".sezzle-checkout-button");
    //   sezzlePay.addEventListener("click", function () {
    //     jQuery.getJSON("/cart.js", function (cart) {
    //       addTotal("$" + cart.total_price / 100);
    //     });
    //   });
    // }, 1000); 
  
    // PayPal

    window.focus();

    window.addEventListener("blur", () => {
      setTimeout(() => {
        if (document.activeElement.tagName === "IFRAME") {
          jQuery.getJSON("/cart.js", function (cart) {
            addTotal("$" + cart.total_price / 100);
          });
        }
      });
    }, { once: false });
  })
}
